import { render } from "./Textarea.vue?vue&type=template&id=2609bbbb"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"
script.render = render

export default script